import { Menu as MenuMantine } from "@mantine/core";

export const MenuTarget = MenuMantine.Target;
